import { Routes, Route } from 'react-router-dom';
import JoinPage from './pages/JoinPage';
import WaitingRoom from './pages/WaitingRoom';
import VideoCall from './pages/VideoCall';
import MeetingEntry from './pages/MeetingEntry';

function App() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Routes>
        <Route path="/" element={<JoinPage />} />
        <Route path="/waiting/:code" element={<WaitingRoom />} />
        <Route path="/call/:code" element={<VideoCall />} />
        {/* Direct meeting code URL: /JOHN-1234 or /JOHN-1234?provider=true */}
        <Route path="/:code" element={<MeetingEntry />} />
      </Routes>
    </div>
  );
}

export default App;
